<template>
    <div style="">
        <v-card>
            <v-toolbar dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Product Category Items</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text dense>
                <v-layout row>
                    <v-flex xs2 body-2 pt-1>
                        <v-select
                        v-model="searchCriteria.classId"
                        :items="itemClasses"
                        item-text="code"
                        item-value="code"
                        label="Class"
                        ></v-select>
                    </v-flex>
                    <v-flex xs3 body-2 pt-1 pl-2>
                        <v-select
                        v-model="searchCriteria.prodDbTypeId"
                        :items="itemProdDbTypesForSearch"
                        label="Product Group"
                        ></v-select>
 
                    </v-flex>
                    <v-flex xs3 body-2 pt-1 pl-2>
                        <v-select
                        v-model="searchCriteria.statusId"
                        :items="itemProdDbStatuses"
                        label="Status"
                        ></v-select>
 
                    </v-flex>
                    <v-flex xs3 body-2 pt-1 pl-2>
                        <v-text-field
                            v-model="searchCriteria.number"
                            label="Product Number"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs4 text-xs-center pt-1>
                        <v-btn @click="onsearchProdDbItems" large color="primary">Search</v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12 body-2 pt-1>Result:</v-flex>

                </v-layout>
                <div class="text-xs-center">
                    <v-pagination
                    v-model="searchCriteria.page"
                    :length="pages"
                    circle
                    ></v-pagination>
                </div>
                <v-layout row>
                    <v-flex xs12 text-xs-left pt-1 >
                        <table style="">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>CLS</th>
                                    <th style="">GROUP</th>
                                    <th style="">STATUS</th>
                                    <th>ITEM NUMBER</th>
                                    <th>ITEM DESC</th>
                                    <!-- <th>ITEM SHORT NAME</th> -->
                                    <th>Product Page Url</th>
                                    <th>BROCHURE</th>
                                    <th>PRICE</th>
                                    <th>MEMO</th>
                                    <th>IFU</th>
                                    <th>SDS</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, idx) in items" :key="item.itemCode">
                                    <td>{{(idx + 1) + (searchCriteria.page - 1) * searchCriteria.recordsPerPage}}</td>
                                    <td>
                                        {{item.itemClass}}
                                    </td>
                                    <td>
                                        <div v-for="prodType in itemProdDbTypes" :key="prodType">
                                            
                                            <span><input type="checkbox" :value="prodType" v-model="item.prodDbTypesAssigned" >{{prodType}}</span>

                                        </div>
                                        <div>
                                            <button class="btnPrimary"  @click="onUpdateProdDbType(item)">
                                                Save
                                            </button>
                                        </div>
                                        <!-- <v-select
                                            v-model="item.prodDbTypesAssigned"
                                            :items="itemProdDbTypes"
                                            attach
                                            chips
                                            multiple
                                        ></v-select>                                         -->
                                    </td>
                                    <td>
                                        <v-select
                                            v-model="item.itemStatus"
                                            :items="itemProdDbStatuses"
                                            label="Status"
                                            ></v-select>
                                        <button class="btnPrimary" @click="onUpdateStatus(item)">Save</button>
                                    </td>
                                    <td>
                                        {{item.itemCode}}
                                        <v-img
                                            :src="item.imgUrlW400"
                                            height="100"
                                            width="100"
                                            contain
                                        ></v-img>                                        

                                    </td>
                                    <td>{{item.itemDesc}}</td>
                                    <!-- <td>{{item.ITEMSHORTNAME}}</td> -->
                                    <td>
                                        <table>
                                            <!-- <thead>
                                                <tr>
                                                    <th>NAME</th>
                                                    <th>PAGE #</th>
                                                    <th>LINK NAME</th>
                                                    <th>LINK</th>
                                                </tr>
                                            </thead> -->
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.productUrlList" :key="idx">
                                                    <td>{{doc.name}}</td>
                                                    <td>{{doc.atPage}}</td>
                                                    <td><a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">{{reduceUrl(doc)}}</a></td>
                                                    <!-- <td>{{doc.urlName}}</td> -->
                                                    <td>
                                                        <button class="btnPrimary" @click="onEditAssignedDoc(doc)">Edit</button>
                                                        <br>
                                                        <button class="btnWarning" @click="onDelDoc(doc)">Del.</button>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td>
                                    <!-- <td>
                                        <table>
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.brochureList" :key="idx">
                                                    <td>{{doc.name}}</td>
                                                    <td>{{doc.atPage}}</td>
                                                    <td><a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">{{reduceUrl(doc)}}</a></td>
                                                    <td>
                                                        <button class="btnPrimary" @click="onEditAssignedDoc(doc)">Edit</button>
                                                        <br>
                                                        <button class="btnWarning" @click="onDelDoc(doc)">Del.</button>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td> -->
                                    <!-- <td>
                                        <table>
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.priceList" :key="idx">
                                                    <td>{{doc.name}}</td>
                                                    <td>{{doc.atPage}}</td>
                                                    <td>
                                                        <a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">
                                                        {{reduceUrl(doc)}}</a>
                                                    </td>
                                                    <td>
                                                        <button class="btnPrimary" @click="onEditAssignedDoc(doc)">Edit</button>
                                                        <br>
                                                        <button class="btnWarning" @click="onDelDoc(doc)">Del.</button>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td> -->
                                    <!-- <td>
                                        <table>
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.memoList" :key="idx">
                                                    <td><a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">{{reduceUrl(doc)}}</a></td>
                                                    <td>
                                                        <button class="btnWarning" @click="onDelDoc(doc)">Del.</button>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.ifuList" :key="idx">
                                                    <td><a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">{{reduceUrl(doc)}}</a></td>
                                                    <td>
                                                        <button class="btnWarning" @click="onDelDoc(doc)">Del.</button>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr v-for="(doc, idx) in item.sdsList" :key="idx">
                                                    <td><a :href="doc.url" v-if="doc.urlName && doc.urlName.trim().length > 0" :class="doc.url?'' : 'red--text'" target="_blank">{{reduceUrl(doc)}}</a></td>
                                                    <td>
                                                        <button class="btnWarning" @click="onDelDoc(doc)">Del.</button>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </td> -->
                                    <td>
                                        <button class="btnPrimary" @click="onAssignNewDoc(item)">New_Doc</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-flex>
                </v-layout>
                <!-- <div class="text-xs-center">
                    <v-pagination
                    v-model="searchCriteria.page"
                    :length="pages"
                    circle
                    ></v-pagination>
                </div> -->
            </v-card-text>
        </v-card>
        <v-dialog v-model="showDocEdit" persistent width="400" height="500">
            <ctlItmAssignedDocEdit 
                :itemXDocEditData="itemXDocEditData"
                @onCloseItemXDocEditData="onCloseItemXDocEditData"
                ></ctlItmAssignedDocEdit>
        </v-dialog>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import ctlItmAssignedDocEdit from '@/components/productDb/ctlItmAssignedDocEdit.vue'

export default {
    components: {
        ctlItmAssignedDocEdit,
    },
    data() {
        return {
            searchCriteria: {
                classId: "All",
                prodDbTypeId: 'Common',
                statusId: 'active',
                number: null,
                page: 1,
                recordsPerPage: 100
                // statusSelected: [1, 5],
                // jobTypeSelected: 0
            },

            itemClasses: [],
            itemProdDbTypesForSearch: ['Common', 'Endo'],
            itemProdDbTypes: ['Common', 'Endo'],
            itemProdDbStatuses: ['active', 'notSold', 'discontinued', 'hidden'],
            pages: null,
            items: [],
            showDocEdit: false,
            itemXDocEditData: null,
        }
    },
    computed: {
    },
    methods: {
        ...mapActions('adminItemProdDb', [
            'searchProdDbItems',
            'deleteItemXDoc',
            'saveItemProdType',
            'saveItemStatus',
        ]),
        async onsearchProdDbItems() {
            // if(!confirm('are you sure to populate data? it just need when first time init data'))
            //     return
            // var payload = {
            //     classId: this.classId,
            //     prodDbTypeId: this.prodDbTypeId,
            //     statusId: this.statusId,
            // }
            var result = await this.searchProdDbItems(this.searchCriteria)
            this.items = result.records
            this.pages = result.pageCount
        },
        ...mapActions('adminItemClass', [
            'getItemClasses',
            'showHideItemClassInWebQuote',
        ]),
        async loadClasses () {
            const result = await this.getItemClasses()
            if (typeof result === 'string') {
                alert(result)
            } else {
                this.itemClasses = [{code: 'All'}, ...result]
            }
        },
        reduceUrl(doc){
            // return doc.url?doc.fileName : "FIX!"
            return doc.url?doc.urlName : "FIX!"
        },
        async onAssignNewDoc(item){

            this.showDocEdit = true
            this.itemXDocEditData = {
                parentProdDbItemId: item.id,
                docCategoryId: 'brochure'
            }
        },
        async onEditAssignedDoc(doc){

            this.showDocEdit = true
            this.itemXDocEditData = doc
        },
        onCloseItemXDocEditData() {
            this.showDocEdit = false
            this.itemXDocEditData = null
            this.onsearchProdDbItems()
        },
        async onUpdateProdDbType(item){

            await this.saveItemProdType(item)
            this.onsearchProdDbItems()
        },
        async onUpdateStatus(item){

            await this.saveItemStatus(item)
            this.onsearchProdDbItems()
        },
        async onDelDoc(doc){
            if(!confirm("Are you sure to delete this doc?")) {
                return
            }
            await this.deleteItemXDoc(doc.id)
            await this.onsearchProdDbItems()
        }
    },
    watch: {
        'searchCriteria.page': {
            handler: function(newVal, oldVal) {
                this.onsearchProdDbItems()
            },
            deep: true
        },
        'searchCriteria.classId': {
            handler: function() {
                this.searchCriteria.page = 1
            },
            deep: true
        }
    },
    async created() {
        await this.loadClasses();
        await this.onsearchProdDbItems()
    },
}
</script>
<style scoped>
    table {
    border-collapse: collapse;
    }

    table, th, td {
    border: 1px solid black;
    }
    .btnPrimary {
        margin: 2px;
        padding: 2px;
        background-color: #0d47a1;
        color: white;
    }
    .btnWarning {
        margin: 2px;
        padding: 2px;
        background-color: #ffc107;
        color: white;
    }
</style>